import { StyledDivider, StyledDividerProps } from "./Divider.styled";

const Divider = (props: StyledDividerProps) => {
  return <StyledDivider className="ui-divider" {...props} />;
};

export default Divider;
